import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Grid, Button, Stack } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

// New Modular Components & Hook
import {
  useCustomerDetail,
  CustomerInfoCard,
  DefinedDevicesCard,
  ServiceHistoryCard,
  CommunicationLogCard,
  CustomerFinancialSummary,

  ExcelExportButton
} from '../modules/customer';
import PageHeader from '../components/common/PageHeader';
import { Loading } from '../components/common/Loading';

const MusteriDetay = () => {
  const { id } = useParams();
  const {
    customer,
    devices,
    serviceHistory,
    communicationLog,
    loading,
    financialSummary,
    balance
  } = useCustomerDetail(id);

  if (loading) { return <Loading message="Müşteri yükleniyor..." />; }
  if (!customer) { return <Typography variant="h5" align="center" sx={{ mt: 4 }}>Müşteri Bulunamadı.</Typography>; }

  return (
    <Box sx={{ p: { xs: 1, md: 2 } }}>
      <PageHeader
        title={customer.adSoyad}
        subtitle="Müşteri detaylarını ve geçmiş işlemlerini buradan yönetebilirsiniz."
        icon={<PersonIcon />}
      >
        <Stack direction="row" spacing={2}>
          <ExcelExportButton
            customer={customer}
            devices={devices}
            serviceHistory={serviceHistory}
            communicationLog={communicationLog}
            balance={balance}
          />
          <Button component={RouterLink} to={`/cari-hesaplar/${id}`} variant="contained" color="primary">
            Cari Hesap Ekstresi
          </Button>
        </Stack>
      </PageHeader>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Stack spacing={3}>
            <CustomerInfoCard customer={customer} />
            <DefinedDevicesCard devices={devices} customerId={customer?.id} />
            <ServiceHistoryCard serviceHistory={serviceHistory} />
            <CommunicationLogCard communicationLog={communicationLog} />
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <CustomerFinancialSummary financialSummary={financialSummary} balance={balance} />
        </Grid>
      </Grid>
    </Box>
  );
};
export default MusteriDetay;
